import { Box, Typography } from '@mui/material'

// Types
import type { JobPostingProps } from '@/types/components/molecules/careers-posting'

// The full posting: intro, each section with its list, then the closing belief
const JobPostingMolecule = (props: JobPostingProps) => {
	// Props
	const { job } = props

	return (
		<Box>
			{job.intro.map(paragraph => (
				<Typography key={paragraph} sx={{ mb: 2, fontSize: { xs: 16, md: 17 }, lineHeight: 2.1 }}>
					{paragraph}
				</Typography>
			))}

			{job.sections.map(section => (
				<Box key={section.title} sx={{ mt: { xs: 5, md: 6 } }}>
					<Typography component="h2" sx={{ fontSize: { xs: 20, md: 24 }, fontWeight: 700 }}>
						{section.title}
					</Typography>

					{section.paragraphs.map(paragraph => (
						<Typography key={paragraph} sx={{ mt: 2, fontSize: 16, lineHeight: 2, color: 'text.secondary' }}>
							{paragraph}
						</Typography>
					))}

					{section.items.length > 0 && (
						<Box component="ul" sx={{ m: 0, mt: 2, p: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 1.25 }}>
							{section.items.map(item => (
								<Box component="li" key={item} sx={{ display: 'flex', gap: 1.5, fontSize: 16, lineHeight: 1.9 }}>
									<Box sx={{ flexShrink: 0, mt: '11px', width: 7, height: 7, borderRadius: '50%', bgcolor: 'primary.main' }} />
									{item}
								</Box>
							))}
						</Box>
					)}
				</Box>
			))}

			{job.quote && (
				<Box
					sx={{
						mt: { xs: 5, md: 6 },
						p: { xs: 3, md: 4 },
						borderRadius: 4,
						bgcolor: 'primary.ultralight',
						borderInlineStart: '4px solid',
						borderColor: 'primary.main'
					}}
				>
					<Typography sx={{ fontSize: { xs: 17, md: 19 }, fontWeight: 700, lineHeight: 1.9 }}>{job.quote}</Typography>
				</Box>
			)}
		</Box>
	)
}

export default JobPostingMolecule
